import { RegisterForm } from '../RegisterForm';
import styles from './RegisterOnly.module.scss';

const RegisterOnly = () => {
  return (
    <div className={styles.registerOnlyContainer}>
      <RegisterForm />
    </div>
  );
};

export default RegisterOnly;
